<template>
    <tr>
        <td class="cursor-pointer" @click="toggleView(item)">{{ capitalizeWords(item) }}</td>
        <td v-for="(value, key) in actions" :key="`${value}_${key}`">
            <!--    <div>{{ userPermissions[item] }}</div>-->
            <v-checkbox v-if="permissions[item].includes(value)"
                        dense
                        hide-details
                        :ripple="false"
                        v-model="userPermissions[item]"
                        :value="`${value}`"
            ></v-checkbox>
        </td>
    </tr>
</template>

<script>
import {mapActions, mapState} from "vuex";
import {PermissionsConstants} from "@/permissions";

export default {
    name: "UserPermissionTable",
    props: ['item', 'userPermissions'],
    data() {
        return {
            actions: PermissionsConstants,
        }
    },
    computed: {
        ...mapState('user', ['activeUser', 'permissions'])
    },
    methods: {
        ...mapActions('user', ['updateUser']),
        capitalizeWords(arr) {
            arr = arr.replaceAll('_', ' ')

            return arr.charAt(0).toUpperCase() + arr.slice(1).toLowerCase();
        },
        toggleView() {
            let permissions = this.userPermissions[this.item];
            if (permissions.length > 0) {
                permissions.splice(0, permissions.length);
            } else {
                this.permissions[this.item].forEach(ap => {
                    if (!permissions.includes(ap)) {
                        permissions.push(ap);
                    }
                });
            }
        },
    }
}
</script>

<style scoped>
.checkbox-row {
    display: flex;
    flex-direction: row
}

.checkbox-padding {
    padding-right: 20px;
}

.cursor-pointer {
    cursor: pointer;
}
</style>